import type { NonEmptyArray } from '@mntn-dev/utility-types'

export function singleOrDefault<T>(array: NonEmptyArray<T>): T
export function singleOrDefault<T>(array: T[] | undefined): T | undefined
export function singleOrDefault<T>(array: (T | null)[]): T | null
export function singleOrDefault<T>(array: (T | undefined)[]): T | undefined
export function singleOrDefault<T>(
  array: (T | null | undefined)[] | undefined
): T | null | undefined {
  const result = array && array.length === 1 ? array[0] : undefined

  return result
}

export function single<T>(array: (T | null | undefined)[] | undefined): T {
  const result = singleOrDefault(array)

  if (result === undefined || result === null) {
    throw new Error('The array does not have exactly one item')
  }

  return result
}
